import { Home, ListTodo, User, Users } from "lucide-react";
import { Link } from "react-router";
import { Logo } from "@/components/logo";
import { SettingsButton } from "@/components/settings/settings-button";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export function RoomHeader({
  roomName,
  isAdmin,
  currentIssueTitle,
  playerName,
  onLeave,
  onInvite,
  onToggleIssues,
}: {
  roomName: string;
  isAdmin: boolean;
  currentIssueTitle: string | undefined;
  playerName: string;
  onLeave: () => void;
  onInvite: () => void;
  onToggleIssues: () => void;
}) {
  return (
    <header className="flex items-center justify-between gap-2 border-b border-border/50 bg-card/50 px-4 py-3 backdrop-blur">
      <div className="flex min-w-0 items-center gap-3">
        <Button asChild variant="ghost" size="icon" className="size-8 shrink-0">
          <Link to="/" onClick={onLeave} aria-label="Back to home" title="Back to home">
            <Home />
          </Link>
        </Button>
        <Logo className="size-5" />
        <h1 className="truncate text-sm font-semibold" data-testid="room-name">
          {roomName}
        </h1>
        {isAdmin && (
          <Badge variant="secondary" className="text-xs">
            Admin
          </Badge>
        )}
      </div>

      <div className="flex shrink-0 items-center gap-2">
        {currentIssueTitle && (
          <Badge variant="outline" className="hidden text-xs sm:flex" data-testid="current-issue">
            {currentIssueTitle}
          </Badge>
        )}
        <div className="hidden items-center gap-1.5 rounded-md bg-secondary/50 px-3 py-1.5 text-sm sm:flex">
          <User className="size-3.5" />
          {playerName}
        </div>
        <SettingsButton />
        <Button variant="outline" size="sm" onClick={onToggleIssues} aria-label="Issues">
          <ListTodo />
          <span className="hidden sm:inline">Issues</span>
        </Button>
        <Button size="sm" onClick={onInvite} aria-label="Invite">
          <Users />
          <span className="hidden sm:inline">Invite</span>
        </Button>
      </div>
    </header>
  );
}
